import React, { useEffect, useState,useRef,useContext } from 'react';
import { Link } from 'react-router-dom';
import HeaderBest from './header';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function GetOffer() {
  const [formData, setFormData] = useState({
    companyName: '',
    phone: '',
    email: '',
    loadingPort: '',
    destinationPort: '',
    equipmentType: '',
    commodity: '',
    commodityDescription: '',
    isDangerous: '',
    imoCode: '',
    class: '',
    potentialVolume: '',
    weightValue: '',
    weightUnit: 'kg',
    comments: ''
  });
  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // IMO kodu kontrolü
    if (formData.isDangerous === 'Yes' && !formData.imoCode) {
      toast.error('Tehlikeli madde seçildiğinde IMO kodu zorunludur');
      return;
    }

    setIsLoading(true);
    
    try {
      const response = await fetch('https://excel.progressytems.com/api/v1/apx/sendmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          subject: 'New Freight Quote Request',
          text: `
            Company Name: ${formData.companyName}
            Phone: ${formData.phone}
            Email: ${formData.email}
            Loading Port: ${formData.loadingPort}
            Destination Port: ${formData.destinationPort}
            Equipment Type: ${formData.equipmentType}
            Commodity: ${formData.commodity}
            Is Dangerous: ${formData.isDangerous}
            IMO Code: ${formData.imoCode}
            Potential Volume: ${formData.potentialVolume}
            Comments: ${formData.comments}
          `
        })
      });

      if (response.ok) {
        toast.success('Quote request sent successfully!');
        setFormData({
          companyName: '',
          phone: '',
          email: '',
          loadingPort: '',
          destinationPort: '',
          equipmentType: '',
          commodity: '',
          commodityDescription: '',
          isDangerous: '',
          imoCode: '',
          class: '',
          potentialVolume: '',
          weightValue: '',
          weightUnit: 'kg',
          comments: ''
        });
      } else {
        toast.error('Failed to send quote request. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('An error occurred. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };
  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    toast.success('Email successfully subscribed!');
    setEmail('');
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <>   <ToastContainer 
    position="bottom-center"
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    theme="light"
    style={{
      zIndex: 9999,
      fontSize: '14px',
      width: 'auto',
      maxWidth: '400px'
    }}
  />
      {/*Preloader*/}
      <div id="preloader" style={{ display: "none" }}>
        <div className="tg-preloader-block">
          <div className="tg-spinner-eff">
            <div className="tg-bar tg-bar-top" />
            <div className="tg-bar tg-bar-right" />
            <div className="tg-bar tg-bar-bottom" />
            <div className="tg-bar tg-bar-left" />
          </div>
        </div>
      </div>
      {/*Preloader-end */}
      {/* Scroll-top */}
      <button className="scroll__top scroll-to-target open" data-target="html" onClick={scrollToTop}>
        <i className="fas fa-angle-up" />
      </button>
      {/* Scroll-top-end*/}
      {/* header-area */}
      <HeaderBest/>
      {/* header-area-end */}
      {/* main-area */}
      <div className='burası'>
      <section
      className="breadcrumb__area breadcrumb__bg"
      data-background="assets/img/bg/breadcrumb_bg.jpg"
      style={{ backgroundImage: 'url("assets/img/breadcrumb_bg.jpg")' }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="breadcrumb__content">
              <h1 className="title">Get Freight Quote</h1>
              <nav className="breadcrumb">
                <span property="itemListElement" typeof="ListItem">
                  <a href="/">Home</a>
                </span>
                <span className="breadcrumb-separator">
                  <i className="flaticon-right-arrow" />
                </span>
                <span property="itemListElement" typeof="ListItem">
                  Get Freight Quote
                </span>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="quote-form-wrapper">
                <h2 className="text-center mb-5">Get Freight Quote</h2>
                <form className="quote-form" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <input 
                          type="text" 
                          className="form-control" 
                          name="companyName"
                          value={formData.companyName}
                          onChange={handleChange}
                          placeholder="Company Name *"
                          required
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <input 
                          type="text" 
                          className="form-control" 
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="Phone Number *"
                          required
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <input 
                          type="email" 
                          className="form-control" 
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Email Address *"
                          required
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <input 
                          type="text" 
                          className="form-control" 
                          name="loadingPort"
                          value={formData.loadingPort}
                          onChange={handleChange}
                          placeholder="Port of Loading *"
                          required
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <input 
                          type="text" 
                          className="form-control" 
                          name="destinationPort"
                          value={formData.destinationPort}
                          onChange={handleChange}
                          placeholder="Port of Discharge *"
                          required
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <select 
                          className="form-control" 
                          name="equipmentType"
                          value={formData.equipmentType}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                        >
                          <option value="">Select Equipment Type *</option>
                          <option value="20 DRY">20 DRY</option>
                          <option value="20 OPEN">20 OPEN</option>
                          <option value="20 REEF">20 REEF</option>
                          <option value="20 TANK">20 TANK</option>
                          <option value="40 DRY">40 DRY</option>
                          <option value="40 FLAT">40 FLAT</option>
                          <option value="40 HDRY">40 HDRY</option>
                          <option value="40 HREF">40 HREF</option>
                          <option value="40 OPEN">40 OPEN</option>
                          <option value="40 REEF">40 REEF</option>
                          <option value="40 TANK">40 TANK</option>
                          <option value="45 HDRY">45 HDRY</option>
                          <option value="45 HREF">45 HREF</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <select 
                          className="form-control" 
                          name="moveType"
                          value={formData.moveType}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                        >
                          <option value="">Select Movie Type *</option>
                          <option value="Port to Port">Port to Port</option>
                          <option value="Port to Door"> Port to Door</option>
                          <option value="Door to Port">Door to Port</option>
                          <option value="Door to Door">Door to Door</option>
      
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <select 
                          className="form-control" 
                          name="grossType"
                          value={formData.grossType}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                        >
                          <option value="">Weight *</option>
                          <option value="Cargo Weight">Net Cargo Weight</option>
                          <option value="Packing Weight">Gross Packing Weight</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <select 
                          className="form-control" 
                          name="weightUnit"
                          value={formData.weightUnit}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                        >
                          <option value="kg">Kilogram (kg)</option>
                          <option value="ton">Ton (t)</option>
                          <option value="lbs">Pound (lbs)</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <input 
                          type="number" 
                          className="form-control" 
                          name="weightValue"
                          value={formData.weightValue}
                          onChange={handleChange}
                          placeholder="Weight Value *"
                          required
                          disabled={isLoading}
                          min="0"
                          step="0.01"
                        />
                      </div>
                    </div>
              
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <select 
                          className="form-control" 
                          name="commodity"
                          value={formData.commodity}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                        >
                          <option value="">Select Commodity Type *</option>
                          <option value="Appliances & kitchenware">Appliances & Kitchenware</option>
                          <option value="Art, antiques">Art & Antiques</option>
                          <option value="Berries">Berries</option>
                          <option value="Beverages">Beverages</option>
                          <option value="Boat">Boat</option>
                          <option value="Chemicals">Chemicals</option>
                          <option value="Diary products">Dairy Products</option>
                          <option value="Foodstuff">Foodstuff</option>
                          <option value="Furniture">Furniture</option>
                          <option value="Machinery">Machinery</option>
                          <option value="Metal">Metal</option>
                          <option value="Textiles & apparel">Textiles & Apparel</option>
                          <option value="Vehicles">Vehicles</option>
                          <option value="Wood">Wood</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                    {formData.commodity === 'Other' && (
                      <div className="col-md-6 mb-4">
                        <div className="form-group">
                          <input 
                            type="text" 
                            className="form-control" 
                            name="commodityDescription"
                            value={formData.commodityDescription}
                            onChange={handleChange}
                            placeholder="Commodity Description *"
                            required
                            disabled={isLoading}
                          />
                        </div>
                      </div>
                    )}
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <select 
                          className="form-control" 
                          name="isDangerous"
                          value={formData.isDangerous}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                        >
                          <option value="">Is it Dangerous Goods? *</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </div>
                    </div>
                    {formData.isDangerous === 'Yes' && (
                      <>
                        <div className="col-md-6 mb-4">
                          <div className="form-group">
                            <input 
                              type="text" 
                              className="form-control" 
                              name="imoCode"
                              value={formData.imoCode}
                              onChange={handleChange}
                              placeholder="IMO Code *"
                              required
                              disabled={isLoading}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-4">
                          <div className="form-group">
                            <input 
                              type="text" 
                              className="form-control" 
                              name="class"
                              value={formData.class}
                              onChange={handleChange}
                              placeholder="Class *"
                              required
                              disabled={isLoading}
                            />
                          </div>
                        </div>
                      </>
                    )}
                    {formData.isDangerous === 'No' && (
                      <div className="col-md-6 mb-4">
                        <div className="form-group">
                          <input 
                            type="text" 
                            className="form-control" 
                            name="imoCode"
                            value={formData.imoCode}
                            onChange={handleChange}
                            placeholder="IMO Code"
                            disabled={isLoading}
                          />
                        </div>
                      </div>
                    )}
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <input 
                          type="text" 
                          className="form-control" 
                          name="potentialVolume"
                          value={formData.potentialVolume}
                          onChange={handleChange}
                          placeholder="Potential Volume *"
                          required
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div className="col-12 mb-4">
                      <div className="form-group">
                        <textarea 
                          className="form-control" 
                          name="comments"
                          value={formData.comments}
                          onChange={handleChange}
                          rows="4" 
                          placeholder="Comments"
                          disabled={isLoading}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-12 text-center">
                      <button 
                        type="submit" 
                        className="btn btn-primary btn-lg"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Sending...
                          </>
                        ) : 'Send'}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* main-area-end */}
      {/* footer-area */}
      <footer className="footer__area fix">
        <div className="container">
          <div className="cta__wrap fix">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="cta__content">
                  <h3 className="title">
                    Fastest &amp; secure way to transport <br /> anything anytime
                  </h3>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cta__btn text-end">
                <Link to="/getoffer" className="btn btn-two">
                    Request a Quote{" "}
                    <svg
                      width={13}
                      height={13}
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                      className="injectable"
                    >
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    </Link>
                </div>
              </div>
            </div>
            <div className="cta__shape">
              <img
                src="/assets/img/cta_shape.png"
                alt="img"
                data-aos="fade-up-right"
                data-aos-delay={400}
                className="aos-init"
              />
            </div>
          </div>
          <div className="footer__top">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-6">
                <div className="footer__widget">
                  <div className="footer__logo">
                  <Link to="/">
                        <img src="/assets/img/mtllogo.png" alt="Logo" />
                      </Link>
                  </div>
                  <div className="footer__content">
                    <p>
                    At MTL, we specialize in logistics solutions tailored to meet diverse delivery needs. 
                    </p>
                  </div>
                  <form onSubmit={handleSubscribe} className="footer__newsletter" style={{display: 'none'}}>
                    <div className="form-grp">
                      <input 
                        type="email" 
                        placeholder="enter your e-mail" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <button type="submit">Subscribe</button>
                    </div>
                    <span>We don't send you any spam</span>
                  </form>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Our Services</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                      <Link to="/">Home</Link>
                      </li>
                      <li>
                      <Link to="/aboutus">About Us</Link>
                      </li>
                      <li>
                      <Link to="/services">Services</Link>
                      </li>
                      <li>
                      <Link to="/blog">Blog</Link>
                      </li>
                      <li>
                      <Link to="/getoffer">Get Offer</Link>
                      </li>
                      <li>
                      <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Other Logistics Companies</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                         <a href="https://mitlog.com.tr/">Mitlog Logistics</a>
                      </li>
                      <li>
                        <a href="https://www.mitlog-airsea.com.tr/">Mitlog Air&Sea Logistics</a>
                      </li>
                     
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Information</h4>
                  <div className="footer__info-wrap">
                    <ul className="list-wrap">
                      <li>
                        <i className="flaticon-location-1" />
                        <p>
                        8451 Market Street ste 138, <br /> Houston Texas 77029 , USA
                        </p>
                      </li>
                      <li>
                        <i className="flaticon-telephone" />
                        <a href="tel:+18325621002">(+1) 832 562 1002</a>
                      </li>
                      <li>
                        <i className="flaticon-time" />
                        <p>
                          Mon – Fri: 8.30- 17.30 EST
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__bottom">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="copyright-text">
                  <p>
                    Copyright @MTL | All Right
                    Reserved
                  </p>
                </div>
              </div>
              <div className="col-md-5">
                <div className="footer__social">
                  <ul className="list-wrap">
                  <li>
                        <a href="https://wa.me/18325621002" target="_blank">
                          <i className="fab fa-whatsapp" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/mtlshipinc" target="_blank">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                
                  
                      <li>
                        <a href="https://www.linkedin.com/company/mtlship" target="_blank">
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
              <li/>
               
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer__shape">
          <img
            src="/assets/img/footer_shape01.png"
            alt="shape"
            data-aos="fade-down"
            data-aos-delay={400}
            className="aos-init"
          />
          <img
            src="/assets/img/footer_shape02.png"
            alt="shape"
            data-aos="fade-left"
            data-aos-delay={400}
            className="aos-init"
          />
        </div>
      </footer>
      {/* footer-area-end */}
      {/* JS here */}
      <style jsx>{`
        .quote-form-wrapper {
          background: #fff;
          padding: 40px;
          border-radius: 10px;
          box-shadow: 0 0 20px rgba(0,0,0,0.1);
          margin: 40px 0;
        }

        .quote-form-wrapper h2 {
          color: #333;
          font-size: 2rem;
          margin-bottom: 30px;
          position: relative;
          padding-bottom: 15px;
        }

        .quote-form-wrapper h2:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 3px;
          background: #c51524;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-control {
          height: 50px;
          padding: 10px 15px;
          border: 1px solid #ddd;
          border-radius: 5px;
          font-size: 14px;
          transition: all 0.3s ease;
        }

        .form-control:focus {
          border-color: #c51524;
          box-shadow: 0 0 0 0.2rem rgba(197, 21, 36, 0.25);
        }

        textarea.form-control {
          height: auto;
          min-height: 100px;
          resize: vertical;
        }

        .btn-primary {
          background: #c51524;
          border: none;
          padding: 12px 30px;
          font-size: 16px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
          transition: all 0.3s ease;
        }

        .btn-primary:hover {
          background: #a3121f;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(197, 21, 36, 0.3);
        }

        select.form-control {
          appearance: none;
          background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
          background-repeat: no-repeat;
          background-position: right 1rem center;
          background-size: 1em;
        }

        @media (max-width: 768px) {
          .quote-form-wrapper {
            padding: 20px;
            margin: 20px 0;
          }

          .quote-form-wrapper h2 {
            font-size: 1.5rem;
          }

          .btn-primary {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
}

export default GetOffer;

